import {
  AdsRefParams,
  AdsWeightParams,
  ChipEnum,
  Icons,
  AdsFilterParams,
  TagColor,
  HomeTypeEnum,
  OwnershipType,
} from '../../enums';
import {
  FilterMinMaxItem,
  FilterTagItem,
  TagItem,
  WeightItemsType,
  CheckboxItem,
  FilterDateItem,
} from '../../types/dataTypes';
import strings from '../../language/Swedish';

const ownerTypes: TagItem[] = [
  {
    id: OwnershipType.coOperativeApartment,
    label: strings.filter.ownertypes.co_operative,
    color: TagColor.blue,
  },
  {
    id: OwnershipType.propertyRights,
    label: strings.filter.ownertypes.property_right,
    color: TagColor.green,
  },
  {
    id: OwnershipType.siteLeasehold,
    label: strings.filter.ownertypes.site_leasehold,
    color: TagColor.amber,
  },
  {
    id: OwnershipType.lease,
    label: strings.filter.ownertypes.lease,
    color: TagColor.pink,
  },
];

const housingTypes = [
  {
    id: HomeTypeEnum.apartment,
    label: strings.filter.housingTypes.apartment,
    color: TagColor.pink,
  },
  {
    id: HomeTypeEnum.house,
    label: strings.filter.housingTypes.house,
    color: TagColor.green,
  },
  {
    id: HomeTypeEnum.terracedHouse,
    label: strings.filter.housingTypes.terracedHouse,
    color: TagColor.orange,
  },
  {
    id: HomeTypeEnum.townhouse,
    label: strings.filter.housingTypes.townhouse,
    color: TagColor.cyan,
  },
  {
    id: HomeTypeEnum.farm,
    label: strings.filter.housingTypes.farm,
    color: TagColor.indigo,
  },
  {
    id: HomeTypeEnum.plot,
    label: strings.filter.housingTypes.plot,
    color: TagColor.violet,
  },
];

const filterItems: {
  tagItems: FilterTagItem[];
  minMaxItems: FilterMinMaxItem[];
  dateItems: FilterDateItem[];
  checkboxItems: CheckboxItem[];
} = {
  tagItems: [
    {
      id: AdsFilterParams.ownership_type,
      label: strings.filter.owner,
      icon: Icons.key,
      items: ownerTypes,
    },
    {
      id: AdsFilterParams.homeType,
      label: strings.filter.housingType,
      icon: Icons.house,
      items: housingTypes,
    },
  ],
  minMaxItems: [
    {
      minId: AdsFilterParams.rooms_min,
      maxId: AdsFilterParams.rooms_max,
      label: strings.filter.rooms,
      icon: Icons.bed,
      valueLabel: '',
      min: 0,
      max: 10,
    },
    {
      minId: AdsFilterParams.living_area_min,
      maxId: AdsFilterParams.living_area_max,
      label: strings.filter.living_area,
      icon: Icons.area,
      valueLabel: 'm\u00B2',
      min: 0,
      max: 500,
    },
    {
      minId: AdsFilterParams.price_min,
      maxId: AdsFilterParams.price_max,
      label: strings.filter.price,
      icon: Icons.coins,
      valueLabel: 'mkr',
      min: 0,
      max: 40,
      type: 'decimal',
    },
    {
      minId: AdsFilterParams.construction_year_min,
      maxId: AdsFilterParams.construction_year_max,
      label: strings.filter.construction_year,
      icon: Icons.crane,
      valueLabel: '',
      min: 1850,
      max: 2024,
    },
    {
      minId: AdsFilterParams.ad_advertising_days_min,
      maxId: AdsFilterParams.ad_advertising_days_max,
      label: strings.filter.advertisingDays,
      icon: Icons.hourglass,
      valueLabel: '',
      min: 0,
      max: 700,
    },
  ],
  dateItems: [],
  checkboxItems: [],
};

const weightItems: WeightItemsType[] = [
  {
    icon: Icons.handShake,
    keyWeightEl: AdsWeightParams.registered_date_weight,
    min: 0,
    max: 1000,
    label: strings.filter.ads_date,
    inputType: ChipEnum.select,
  },
  {
    icon: Icons.pin,
    keyWeightEl: AdsWeightParams.distance_weight,
    min: 0,
    max: 1000,
    label: strings.filter.distance,
    inputType: ChipEnum.select,
  },
  {
    icon: Icons.bed,
    keyWeightEl: AdsWeightParams.rooms_weight,
    keyRefEl: AdsRefParams.rooms_reference,
    min: 0,
    max: 10,
    weight: 500,
    label: strings.filter.rooms,
    inputType: ChipEnum.slider,
  },
  {
    icon: Icons.area,
    keyWeightEl: AdsWeightParams.living_area_weight,
    keyRefEl: AdsRefParams.living_area_reference,
    min: 0,
    max: 500,
    weight: 500,
    label: strings.filter.living_area,
    inputType: ChipEnum.slider,
    unit: strings.filter.living_area_unit,
  },
  {
    icon: Icons.dollar,
    keyWeightEl: AdsWeightParams.monthly_fee_weight,
    keyRefEl: AdsRefParams.monthly_fee_reference,
    min: 0,
    max: 15000,
    weight: 500,
    label: strings.filter.monthly_fee,
    inputType: ChipEnum.slider,
    unit: strings.filter.monthly_fee_unit,
  },
  {
    icon: Icons.crane,
    keyWeightEl: AdsWeightParams.construction_year_weight,
    keyRefEl: AdsRefParams.construction_year_reference,
    min: 1800,
    max: 2024,
    weight: 500,
    label: strings.filter.construction_year,
    inputType: ChipEnum.slider,
  },
  {
    icon: Icons.apartment,
    keyWeightEl: AdsWeightParams.floor_weight,
    keyRefEl: AdsRefParams.floor_reference,
    min: 0,
    max: 75,
    weight: 500,
    label: strings.filter.floor,
    inputType: ChipEnum.slider,
  },
];

export { weightItems, filterItems };
